import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Layout } from 'antd';
import dayjs from 'dayjs';

import { TableWithForm } from 'components';

import { useGetHeaders, useUserRole } from 'hooks';

import { DownloadCSVButton } from './DownloadCSVButton';
import { columns, fields, handleProductMatchesTableChange } from './lib';

export const ProductMatches = () => {
  const [url, setUrl] = useState('');

  const { productId } = useParams();

  const headers = useGetHeaders();

  const { isAdmin } = useUserRole();

  return (
    <Layout className='h-[700px]'>
      <TableWithForm
        horizontalScroll
        id='product-matches-table'
        size='small'
        columns={columns}
        titleExtraNode={<DownloadCSVButton url={url} />}
        defaultTableParams={{ current: 1, pageSize: 20 }}
        onTableChange={handleProductMatchesTableChange(headers, setUrl, productId)}
        // form
        fields={fields(isAdmin)}
        labelCol={{ span: 0 }}
        wrapperCol={{ span: 24 }}
        formInitialValues={{ submittedDates: [dayjs().subtract(30, 'day'), dayjs().endOf('day')] }}
      />
    </Layout>
  );
};
